import { render } from "./UploadedImage.vue?vue&type=template&id=dc34df52&scoped=true"
import script from "./UploadedImage.vue?vue&type=script&lang=js"
export * from "./UploadedImage.vue?vue&type=script&lang=js"

import "./UploadedImage.vue?vue&type=style&index=0&id=dc34df52&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc34df52"]])

export default __exports__